module.exports = __webpack_public_path__ + "static/media/ooze.61e72e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/textures/ooze.png
// module id = 2738
// module chunks = 0